import { useEffect, useState } from "react";
import { Luggage, CreditCard, FileText, Plane, TrendingUp } from "lucide-react";
import api, { fcfa } from "@/lib/api";

export default function Overview() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="py-10 text-center"><div className="h-8 w-8 rounded-full border-4 border-accent border-t-transparent animate-spin mx-auto" /></div>;

  const cards = [
    { label: "Réservations aujourd'hui", value: data.bookings_today, icon: Luggage, color: "text-blue-600 bg-blue-50" },
    { label: "Paiements confirmés", value: data.paid_count, icon: CreditCard, color: "text-green-600 bg-green-50" },
    { label: "Dossiers visa en cours", value: data.visa_in_progress, icon: FileText, color: "text-purple-600 bg-purple-50" },
    { label: "Devis vol nouveaux", value: data.flight_new, icon: Plane, color: "text-orange-600 bg-orange-50" },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.label} className="bg-white rounded-2xl soft-shadow border border-gray-100 p-5" data-testid={`kpi-${c.label}`}>
              <span className={`h-10 w-10 rounded-xl flex items-center justify-center mb-3 ${c.color}`}>
                <Icon className="h-5 w-5" />
              </span>
              <div className="font-head text-3xl font-extrabold text-primary">{c.value}</div>
              <div className="text-xs text-muted-foreground mt-1">{c.label}</div>
            </div>
          );
        })}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="bg-gradient-to-br from-primary to-blue-900 rounded-2xl p-6 text-white">
          <div className="flex items-center gap-2 text-accent mb-2"><TrendingUp className="h-5 w-5" /> Revenu confirmé</div>
          <div className="font-head text-3xl font-extrabold">{fcfa(data.revenue)}</div>
          <p className="text-white/60 text-sm mt-1">{data.paid_count} réservation(s) payée(s)</p>
        </div>
        <div className="bg-white rounded-2xl soft-shadow border border-gray-100 p-6">
          <div className="text-sm text-muted-foreground">En attente de paiement</div>
          <div className="font-head text-3xl font-extrabold text-amber-600">{data.pending_count}</div>
          <div className="text-sm text-muted-foreground mt-3">Preuves manuelles à vérifier</div>
          <div className="font-head text-2xl font-extrabold text-primary">{data.manual_pending}</div>
        </div>
      </div>

      <div className="bg-white rounded-2xl soft-shadow border border-gray-100 p-6">
        <h3 className="font-head font-bold text-lg text-primary mb-4">Dernières réservations</h3>
        <div className="space-y-2">
          {data.recent_bookings?.length === 0 && <p className="text-sm text-muted-foreground">Aucune réservation.</p>}
          {data.recent_bookings?.map((b) => (
            <div key={b.id} className="flex items-center justify-between py-2 border-b border-gray-50 text-sm">
              <div>
                <span className="font-semibold text-primary">{b.offer_title}</span>
                <span className="text-muted-foreground"> — {b.user_name}</span>
              </div>
              <span className="font-semibold text-accent">{fcfa(b.total_amount)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
